import { Content } from "@/react/components/Spaces/CourseSpace/Summary/Content";
import {
  useCurrentSpaceContext,
  useSpaceResource,
} from "@circle-react/contexts";
import {
  canManageSpace,
  isSpaceMember,
} from "@circle-react/helpers/spaceHelpers";
import { AdminSummary } from "../AdminSummary";
import { usePreviewAsStudent } from "../Shared/usePreviewAsStudent";
import { EmptyLessonsCount } from "./EmptyLessonsCount";
import { Progress } from "./Progress";
import { WelcomeBanner } from "./WelcomeBanner";

export const Summary = () => {
  const { data: space } = useCurrentSpaceContext();
  const { space: spaceResource } = useSpaceResource({
    spaceId: space?.id,
  });
  const { isCoursePreview } = usePreviewAsStudent();

  const totalLessons =
    spaceResource?.course_sections.reduce(
      (total, section) => total + section.lessons.length,
      0,
    ) ?? 0;

  if (!spaceResource) {
    return null;
  }

  if (canManageSpace(spaceResource) && !isCoursePreview) {
    return <AdminSummary />;
  }

  const isMember = isSpaceMember(spaceResource);

  return (
    <div className="bg-primary h-full p-4">
      <div className="mx-auto flex max-w-[800px] flex-col items-center space-y-10 py-8 md:items-start">
        {isMember && (
          <>
            <WelcomeBanner />
            <Progress />
          </>
        )}
        {totalLessons > 0 ? (
          <Content
            isMember={isMember}
            sections={spaceResource.course_sections}
          />
        ) : (
          <EmptyLessonsCount />
        )}
      </div>
    </div>
  );
};
